<template>
  <div class="trans-main">
    <div class="trans-header">
      <div class="trans-header-select">
        <div :class="activeLabDoc" data-track-text="H5切换文档翻译" aria-label="H5切换文档翻译" @click="clickShowDoc('0')">文档</div>
        <div :class="activeLabTxt" data-track-text="H5切换文本翻译" aria-label="H5切换文本翻译" @click="clickShowDoc('1')">文本</div>
      </div>
    </div>
    <div v-show="showDoc" class="trans-main-content">
      <div v-show="!showUploadOk" class="trans-main-content-ok">
        <div class="trans-main-content-ok-font">
          <div>上传成功</div>
          <div><img src="../../assets/H5/upload-success.png" alt="" width="44"/></div>
        </div>
        <div class="trans-main-content-ok-button" data-track-text="查看或支付翻译结果" aria-label="查看或支付翻译结果" @click="toPath">
          {{isShowFree?'立即查看':'立即支付'}}
        </div>
      </div>
      <div v-show="showUploadOk" class="trans-main-content-select">
        <div>
          <el-select v-model="uploadform.from" filterable placeholder="原文语言" popper-class="custom-select-class">
            <el-option-group
                v-for="group in lanuagesFrom"
                :key="group.value"
                :label="group.label"
            >
              <el-option
                  v-for="item in group.lanuagesFrom"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div><img @click="zhuanhuan" data-track-text="切换语种" aria-label="切换语种" src="../../assets/H5/trans-convert.png" alt="" width="32"/></div>
        <div>
          <el-select v-model="uploadform.to" filterable placeholder="目标语言" popper-class="custom-select-class">
            <el-option-group
                v-for="group in lanuagesTo"
                :key="group.value"
                :label="group.label"
            >
              <el-option
                  v-for="item in group.lanuagesFrom"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <el-form v-show="showUploadOk"
               ref="uploadForm"
               :rules="uploadrules"
               :model="uploadform"
               :inline="true"
               class="demo-form-inline"
               style="width: 100%;margin-top: 68px;margin-bottom: 182px;display: flex;align-items: center;justify-content: center;"
      >
        <div @click="getUserStatus" data-track-text="上传翻译文档" aria-label="上传翻译文档">
          <el-upload
              :class="elUploadMdjy"
              :disabled="isUploadDisabled"
              action
              drag
              multiple
              ref="fileUpload"
              class="new-upload-demo"
              accept=".doc, .docx, .pdf, .txt, .xls, .xlsx, .ppt, .pptx"
              :limit="count"
              :on-exceed="onExceed"
              :file-list="fileList"
              :auto-upload="autoUpload"
              :before-upload="beforeUpload"
              :http-request="submitUploadFiles"
              :on-error="onError"
              :on-success="onSuccess"
              :on-remove="handleRemove"
          >
            <div :class="elUploadMdjy">
              <div class="content">
                <div class="el-upload-titjy">
                  拖入/选择 要翻译的文档
                  <span style="color: #999999">（可批量上传）</span>
                </div>
                <div class="scbncg">
                  <span style="color: #999999;font-size: 24px;">上传文档不能超过20M</span>
                </div>
                <div class="uptitle">
                  上传文档
                </div>
              </div>
            </div>
          </el-upload>
        </div>
      </el-form>
      <div :class="showupload">
        <el-divider>支持以下上传格式</el-divider>
        <div class="list">
          <div>
            <img src="../../assets/img/ppt.png"/>
            <span class="hit-span3">ppt/pptx</span>
          </div>
          <div>
            <img src="../../assets/img/txt.png"/>
            <span class="hit-span3">txt</span>
          </div>
          <div>
            <img src="../../assets/img/pdf.png"/>
            <span class="hit-span2">pdf</span>
          </div>
          <div>
            <img src="../../assets/img/xls.png"/>
            <span class="hit-span4">xls/xlsx</span>
          </div>
          <div>
            <img src="../../assets/img/doc.png"/>
            <span class="hit-span1">doc/docx</span>
          </div>
        </div>
        <div class="triangle"><span>暂不支持的</span><span
            style="color: #DF2525">pdf文档</span><span>(做过OCR处理)：1.文字无法拷贝；2. 文字放大显示后呈现锯齿状线条
</span></div>
      </div>
    </div>
    <div v-show="showTxt" class="trans-main-content-text">
      <div class="trans-main-content-select">
        <div>
          <el-select v-model="uploadform.from" filterable placeholder="原文语言" popper-class="custom-select-class">
            <el-option-group
                v-for="group in lanuagesFrom"
                :key="group.value"
                :label="group.label"
            >
              <el-option
                  v-for="item in group.lanuagesFrom"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div><img @click="zhuanhuan" data-track-text="切换语种" aria-label="切换语种" src="../../assets/H5/trans-convert.png" alt="" width="32"/></div>
        <div>
          <el-select v-model="uploadform.to" filterable placeholder="目标语言" popper-class="custom-select-class">
            <el-option-group
                v-for="group in lanuagesTo"
                :key="group.value"
                :label="group.label"
            >
              <el-option
                  v-for="item in group.lanuagesFrom"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="text-input">
        <div style="border-right: 1px solid #DDDDDD;">
          <div>
            <el-input class="originaltext"
                      type="textarea"
                      placeholder="请输入您要翻译的文字"
                      v-model="originaltext"
                      maxlength="2000"
                      show-word-limit
                      resize="none"
                      :autofocus="true"
                      :autosize="{ minRows:8, maxRows: 8}"
                      @keyup.enter.native="submitTransText"
            >
            </el-input>
          </div>
        </div>
        <div>
          <el-input class="originaltext"
                    type="textarea"
                    v-model="translatetext"
                    :readonly="true"
                    resize="none"
                    :autofocus="true"
                    :autosize="{ minRows:8, maxRows: 8}"
          >
          </el-input>
        </div>
      </div>
    </div>
    <div v-show="showTxt" class="trans-main-content-text-tip">
      automatic detection
    </div>
    <el-dialog :visible.sync="dialogTableVisible" :close-on-click-modal="false" class="payClass1">
      <div slot="title" class="dialog-title">
        <span class="fanyiyuyan">翻译语言：</span>
        <div style="display: inline">
          <el-form
              ref="uploadForm"
              :rules="uploadrules"
              :model="uploadform"
              :inline="true"
              class="demo-form-inline"
              style=""
          >
            <el-form-item prop="from">
              <template>
                <el-select
                    class="borderSelect"
                    v-model="uploadform.from"
                    filterable
                    placeholder="原文语言"
                >
                  <el-option-group
                      v-for="group in lanuagesFrom"
                      :key="group.value"
                      :label="group.label"
                  >
                    <el-option
                        v-for="item in group.lanuagesFrom"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </template>
            </el-form-item>
            <i class="el-icon-right" style="    transform: scale(2,0.8) !important;
    width: 18px;
    margin-left: 10px;"></i>
            <el-form-item
                prop="to"
            >
              <template>
                <el-select
                    class="borderSelect"
                    v-model="uploadform.to"
                    filterable
                    placeholder="目标语言"
                >
                  <el-option-group
                      v-for="group in lanuagesFrom"
                      :key="group.value"
                      :label="group.label"
                  >
                    <el-option
                        v-for="item in group.lanuagesFrom"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </template>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table :data="gridData"
                :header-cell-style="{ 'background': '#d3dee8','line-height': '30px','height': '23px',
                'text-align':'center','font-size':'14px','color':'#333333'}"
      >
        <el-table-column type="index" property="id" label="序号" width="50" align="center"></el-table-column>
        <el-table-column property="title" label="题名" show-overflow-tooltip></el-table-column>
        <el-table-column property="page" label="校验页数" width="100" align="center"></el-table-column>
        <el-table-column property="money" label="金额（元）" width="100" align="center"
                         v-if="isShowMoney"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <div style="float: left;
    font-size: 14px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #333333;
    width: 80%;">
          <div style="float: left">
            总计：<span>{{ pages }}</span>页
          </div>
          <div style="float: right" v-if="isShowMoney">
            <span style="padding-right: 15px;">总价：￥{{ NumFilter(orderMoney) }}</span>
            <span style="padding-right: 15px;">优惠：
              <span style="color:#e13f3f;">{{ NumberSub(orderMoney, moneys) }}</span>
            </span>
            <span style="padding-right: 15px;">实付：<span
                style="color:#e13f3f ;font-size: 18px;">￥{{ NumFilter(moneys) }}</span></span>
          </div>
        </div>
        <el-button v-if="!isShowFree" type="primary" data-track-text="H5确认翻译" aria-label="H5确认翻译" @click="submitPay" class="okTranslate">确认翻译</el-button>
        <el-button v-if="isShowFree" type="primary" data-track-text="H5免费翻译" aria-label="H5免费翻译" @click="submitPay" class="okTranslate">免费翻译</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {authServiceClient, translateServiceClient} from "@/tools/api/service";
import {outRequest, userPowerRequest, userStatusRequest} from "@/tools/api/auth-api";
import lanuagefrom from "../../../languagefrom.json";
import languageto from "../../../languageto.json";
import languages from "../../../language.json";
import {
  parentPowerRequest,
  submitRequest,
  transTextRequest,
  uploadCountRequest, uploadRequest,
  uploadTipRequest,
  checkRoamingRequest
} from "@/tools/api/translate-api";

export default {
  name: "Trans",
  data() {
    return {
      isShowTransPro: false,
      qrcodeUrl: '',
      showRoaming: false,
      groupUserInfos: [],
      userInfo: '',
      userType: '',
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      groupUserInfo: '',
      activeLabDoc: 'is-active',
      activeLabTxt: '',
      activeLabImg: '',
      languages2: "languages",
      languages: "languages",
      originalFrom: "自动检测",
      originalTo: "中文(简体)",
      originaltext: "",
      translatetext: "",
      showTxt: false,
      showDoc: true,
      showUploadOk: true,
      showImg: false,
      isShowMoney: false,
      isShowFree: false,
      orderMoney: 0,
      moneys: 0,
      pages: 0,
      idData: [],
      dialogTableVisible: false,
      gridData: [],
      title: '',
      isShowInRoaming: false,
      selectOption: 'selectOption',
      uploadCount: 0,
      limitCount: 20,
      count: 10,
      isUploadDisabled: true,
      isImgUploadDisabled: true,
      isShowupload: true,
      showupload: "new-el-upload-manjy",
      elUploadMdjy: "new-el-upload-mdjy",
      showUpload1: true,
      showUpload2: true,
      timer: "",
      time: "",
      autoUpload: true,
      hasUpload: false,
      lanuagesFrom: lanuagefrom,
      lanuagesTo: languageto,
      uploadform: {
        from: "auto",
        to: "zh",
      },
      uploadrules: {
        from: [{required: true, message: "请输入原文语言", trigger: "blur"}],
        to: [{required: true, message: "请输入目标语言", trigger: "blur"}],
      },
      fileList: [],
      uploadLoading: false,
      one: true,
      two: false,
      three: false,
      four: false,
      one2: true,
      two2: false,
      three2: false,
      lastTime: 0,
      userId: '',
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
    }
  },
  mounted() {
    const that = this;
    this.checkUploadCountByDay1();
    this.timer = setInterval(function () {
      let x = document.getElementsByClassName("el-progress__text");
      let count = 0;
      for (let i = 0; i < x.length; i++) {
        if (x[i].innerHTML === "100%") {
          count = count + 1;
          x[i].parentNode.previousSibling.previousSibling.previousSibling.style.display = "block";
        }
      }
      if (x.length !== 0 && count === x.length) {
        clearInterval(that.timer);
        setTimeout(function () {
          that.showUploadOk = false;
        }, 1500);
      }
    }, 10);
  },
  watch: {
    dialogTableVisible(val) {
      if (!val) {
        this.$refs.fileUpload.clearFiles();
        this.$refs.fileUpload.$data.uploadFiles = [];
        this.idData = [];
        this.gridData = [];
        this.orderMoney = 0;
        this.moneys = 0;
        this.pages = 0;
        this.isUploadDisabled = false;
        this.elUploadMdjy = "new-el-upload-mdjy";
        this.$router.push("/list");
      } else {
        let request = parentPowerRequest;
        request.setMoney(this.moneys)
        const TOKEN_KEY = "token";
        translateServiceClient.checkParentPower(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          this.isShowMoney = res.getShowmoney();
          if (this.isShowMoney && this.moneys === 0) {
            this.isShowFree = true;
          }
        }).catch(err => {
          this.isShowMoney = true;
        })
      }
    },
    originaltext(val) {
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      } else {
        clearTimeout(this.lastTime)
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      }
    },
    "uploadform.from": function (val) {
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      } else {
        clearTimeout(this.lastTime)
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      }
    },
    "uploadform.to": function (val) {
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      } else {
        clearTimeout(this.lastTime)
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.isRoamingTimer);
    clearTimeout(this.isRoamingTimerOut);
  },
  beforeCreate() {
    const TOKEN_KEY = 'token';
    authServiceClient.getUserStatus(userStatusRequest, {
      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
    }).then(res => {
      if (!res.getStatus()) {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.groupUserInfo = "";
        this.showRoaming = false;
        return;
      }
      const user = localStorage.getItem('auth-context');
      if (!user) {
        return
      }
      const userJson = JSON.parse(user);
      const Base64 = require('js-base64').Base64;
      userJson.forEach(item => {
        if (item.type === 'Person' || item.type === 'Child') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          if (item.type === 'Person') {
            this.userType = '0'
          }
          if (item.type === 'Child') {
            this.userType = '1'
          }
          this.userInfo = realName
          this.userId = item.name;
          if (!item.isRoaming) {
            let roaming = localStorage.getItem(this.userId)
            if (!roaming || roaming !== '1') {
              this.showRoaming = true
            } else {
              this.showRoaming = false
              this.userType = '2'
            }
          } else {
            this.userType = '2'
          }
          if (this.groupUserInfo === '') {
            this.groupUserInfo = '机构登录';
          }
          this.showloginOut = true
        }
        if (item.type === 'Group') {
          this.groupUserInfos.push(item)
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.groupUserInfo = realName;
          this.url = process.env.VUE_APP_WEB_LOGIN_URL;
        }
      })
    }).catch(err => {
      localStorage.removeItem("token")
      localStorage.removeItem("auth-context")
      this.userInfo = "";
      this.showRoaming = false;
    });
  },
  created() {
    this.getUploadTip();
  },
  methods: {
    toCenter() {
      window.open("https://user.wesitrans.com/account", '_blank')
    },
    getQrcode() {
      this.qrcodeUrl = "http://common.wesitrans.com/common/roaming/qrcode"
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000)
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== '1') {
        let request = checkRoamingRequest
        request.setUserId(this.userId)
        const TOKEN_KEY = "token";
        translateServiceClient.checkRoaming(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          localStorage.setItem(this.userId, res.getMessage())
          if (res.getMessage() === '1') {
            window.location.reload()
          }
        }).catch(err => {
        })
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      }
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", '_blank')
        return;
      }
      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo)
      } else {
        request.setName(val)
      }
      const TOKEN_KEY = 'token';
      authServiceClient.logOut(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        window.location.reload();
        this.$router.push("/index")
      }).catch(err => {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.showRoaming = false;
        this.$router.push("/h5/login")
      });
    },
    toPath(url) {
      if (url === '/trans-pro') {
        window.open("/trans-pro/index", "_self")
        return;
      }
      if (url === '/list' || url === '/list-pro') {
        const TOKEN_KEY = 'token';
        authServiceClient.getUserStatus(userStatusRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          if (!res.getStatus()) {
            localStorage.removeItem("token")
            localStorage.removeItem("auth-context")
            this.$router.push("/h5/login")
            return;
          }
          if (localStorage.getItem('auth-context') &&
              localStorage.getItem('token')) {
            authServiceClient.checkUserPower(userPowerRequest, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
            }).then(res => {
              if (res.getStatus()) {
                this.$router.push(url)
                return;
              }
              this.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              this.$router.push("/h5/login")
            }).catch(err => {
              this.$router.push("/h5/login")
            })
          }
        }).catch(err => {
          this.$router.push("/h5/login")
        });
        return
      }
      this.$router.push(url);
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient.getUploadTip(uploadTipRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowTransPro = res.getIsTransPro();
        this.isShowInRoaming = res.getIsRoaming();
        this.title = res.getMessage();
        if (this.title === undefined || this.title === null || this.title === '') {
          this.selectOption = "selectOption1"
        }
      }).catch(err => {
        this.isShowInRoaming = false;
        this.isShowTransPro = true;
        this.title = '';
        this.selectOption = "selectOption1"
      });
    },
    submitTransText() {
      if (!this.originaltext) {
        return
      }
      const text = this.originaltext.replace(/\s+/g, "");
      if (text === null || text === "") {
        return
      }
      if (this.uploadform.from === this.uploadform.to) {
        this.translatetext = this.originaltext
        return
      }
      this.translatetext = "正在翻译...";
      let request = transTextRequest;
      request.setText(this.originaltext)
      request.setFrom(this.uploadform.from)
      request.setTo(this.uploadform.to)
      translateServiceClient.submitTransText(request).then(res => {
        this.translatetext = res.getText()
      }).catch(err => {
        this.translatetext = "翻译失败，请重试。"
      })
    },
    leaveTab(activeName, oldActiveName) {
    },
    getUserStatus() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient
          .getUserStatus(userStatusRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          }).then((res) => {
        if (!res.getStatus()) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.$router.push("/h5/login")
          return false;
        }
        const user = localStorage.getItem("auth-context");
        if (!user) {
          this.$router.push("/h5/login")
          return false;
        }
        return that.checkUserPower();
      }).catch((err) => {
        localStorage.removeItem("token");
        localStorage.removeItem("auth-context");
        this.$router.push("/h5/login")
        return false;
      });

    },
    checkUserPower() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient.checkUserPower(userPowerRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      })
          .then(res => {
            if (!res.getStatus()) {
              that.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              this.$router.push("/h5/login")
              return false;
            }
            return that.checkUploadCountByDay();
          }).catch(err => {
        this.$router.push("/h5/login")
        return false;
      })
    },
    checkUploadCountByDay() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              that.$message.error(res.getMessage());
              that.isUploadDisabled = true;
              that.elUploadMdjy = "new-el-upload-mdjy-none";
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            that.elUploadMdjy = "new-el-upload-mdjy";
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch(err => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              this.$router.push("/h5/login")
            } else {
              that.$message.error("文件上传遇到了问题，请稍后再试！");
            }
            return false;
          })
    },
    checkUploadCountByDay1() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              that.$message.error(res.getMessage());
              that.isUploadDisabled = true;
              that.isImgUploadDisabled = true;
              that.elUploadMdjy = "new-el-upload-mdjy-none";
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            that.isImgUploadDisabled = false;
            that.elUploadMdjy = "new-el-upload-mdjy";
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch(err => {
            return false;
          })
    },
    clickShowDoc(target) {
      if (target === "0") {
        this.showTxt = false
        this.showImg = false
        this.showDoc = true
        this.activeLabDoc = 'is-active'
        this.activeLabTxt = ''
        this.activeLabImg = ''
      }
      if (target === "1") {
        this.showTxt = true
        this.showDoc = false
        this.showImg = false
        this.activeLabDoc = ''
        this.activeLabTxt = 'is-active'
        this.activeLabImg = ''
      }
      if (target === "2") {
        this.showTxt = false
        this.showDoc = false
        this.showImg = true
        this.activeLabDoc = ''
        this.activeLabTxt = ''
        this.activeLabImg = 'is-active'
      }
    },
    submitPay() {
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitRequest;
      if (this.uploadform.from === "原文语言") {
        this.uploadform.from = "auto";
      }
      if (this.uploadform.to === "目标语言") {
        this.uploadform.to = "zh";
      }
      request.setIdsList(ids).setFrom(this.uploadform.from).setTo(this.uploadform.to).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submit(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          this.$router.push("/list");
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    closeTip() {
      this.selectOption = "selectOption1"
    },
    yuwenClose1(event) {
      this.showUpload1 = !event;
      if (this.showUpload1 && this.showUpload2) {
        this.showupload = 'new-el-upload-manjy'
        this.isShowupload = true;
        this.languages = "languages";
      } else {
        this.showupload = 'new-el-upload-manjy-display'
        this.isShowupload = false;
        this.languages = "openlanguages";
      }
      if (this.uploadform.from) {
        this.originalFrom = this.getChineseName(this.uploadform.from)
        this.one = true;
        this.two = false;
        this.three = false;
        this.four = false;
      }
    },
    yuwenClose2(event) {
      this.showUpload2 = !event;
      if (this.showUpload1 && this.showUpload2) {
        this.showupload = 'new-el-upload-manjy'
        this.isShowupload = true;
        this.languages2 = "languages";
      } else {
        this.showupload = 'new-el-upload-manjy-display'
        this.isShowupload = false;
        this.languages2 = "openlanguages";
      }
      if (this.uploadform.to) {
        this.originalTo = this.getChineseName(this.uploadform.to)
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
    },
    onSuccess() {
      return false;
    },
    handleRemove(file) {
      this.$refs.fileUpload.abort(); //取消上传
      this.$refs.fileUploadImg.abort();
    },
    onError(err, file, fileList) {
    },
    changeLanuage2(event) {
      if (
          (event.target.innerText === "中文(简体)" && this.one2) ||
          (event.target.innerText === "英语" && this.two2) ||
          (event.target.innerText === "日语" && this.three2)
      ) {
        this.one2 = false;
        this.two2 = false;
        this.three2 = false;
        this.uploadform.to = "zh";
        return;
      }
      this.one2 = false;
      this.two2 = false;
      this.three2 = false;
      if (event.target.innerText === "中文(简体)") {
        this.uploadform.to = "zh";
        this.one2 = true;
        return;
      }
      if (event.target.innerText === "英语") {
        this.uploadform.to = "en";
        this.two2 = true;
        return;
      }
      if (event.target.innerText === "日语") {
        this.uploadform.to = "ja";
        this.three2 = true;
        return;
      }
      this.one2 = true;
    },
    zhuanhuan() {
      if (this.uploadform.from === "auto") {
        this.$message.error("请选择原文件语言");
        return
      }
      if (this.uploadform.from !== "zh" && this.uploadform.from !== "en" && this.uploadform.from !== "ja") {
        this.originalTo = this.getChineseName(this.uploadform.from)
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
      if (this.uploadform.to !== "zh" && this.uploadform.to !== "en" && this.uploadform.to !== "ja") {
        this.originalFrom = this.getChineseName(this.uploadform.to);
        this.one = true;
        this.two = false;
        this.three = false;
        this.four = false;
      }
      if (this.uploadform.from === "zh") {
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
      if (this.uploadform.from === "en") {
        this.one2 = false;
        this.two2 = true;
        this.three2 = false;
      }
      if (this.uploadform.from === "ja") {
        this.one2 = false;
        this.two2 = false;
        this.three2 = true;
      }
      if (this.uploadform.to === "zh") {
        this.one = false;
        this.two = true;
        this.three = false;
        this.four = false;
      }
      if (this.uploadform.to === "en") {
        this.one = false;
        this.two = false;
        this.three = true;
        this.four = false;
      }
      if (this.uploadform.to === "ja") {
        this.one = false;
        this.two = false;
        this.three = false;
        this.four = true;
      }
      const tmp = this.uploadform.from;
      this.uploadform.from = this.uploadform.to;
      this.uploadform.to = tmp;
    },
    changeLanuage(event) {
      this.one = false;
      this.two = false;
      this.three = false;
      this.four = false;
      if (event.target.innerText === "自动检测") {
        this.uploadform.from = "auto";
        this.one = true;
        return;
      }
      if (event.target.innerText === "中文(简体)") {
        this.uploadform.from = "zh";
        this.two = true;
        return;
      }
      if (event.target.innerText === "英语") {
        this.uploadform.from = "en";
        this.three = true;
        return;
      }
      if (event.target.innerText === "日语") {
        this.uploadform.from = "ja";
        this.four = true;
        return;
      }
      this.one = true;
    },
    getChineseName(lanuage) {
      let label = lanuage;
      languages.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      });
      return label;
    },
    submitUploadFiles(event) {
      let time
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              this.elUploadMdjy = "new-el-upload-mdjy-none";
              return
            }
            this.isShowupload = false;
            this.isUploadDisabled = false;
            this.elUploadMdjy = "new-el-upload-mdjy";
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            this.elUploadMdjy = "new-el-upload-mdjy-display";
            //上传进度
            let unm = 0;
            event.onProgress({percent: unm});
            time = setInterval(function () {
              let Range = 5 - 1;
              let Rand = Math.random();
              unm = 1 + Math.round(Rand * Range) + unm;
              if (unm > 99) {
                unm = 99;
              }
              event.onProgress({percent: unm});
            }, 100);
            if (this.uploadform.from === "原文语言") {
              this.uploadform.from = "auto";
            }
            if (this.uploadform.to === "目标语言") {
              this.uploadform.to = "zh";
            }
            const files = this.$refs.fileUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            let request = uploadRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            const thatEvent = event;
            reader.onloadend = () => {
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadform.from);
              request.setTo(this.uploadform.to);
              translateServiceClient
                  .upload(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    clearInterval(time);
                    if (res.getStatus()) {
                      thatEvent.onProgress({percent: 100})
                      const file = res.getUploadfile();
                      const data = {};
                      data.id = file.getId();
                      data.title = file.getTitle();
                      data.page = file.getPage();
                      data.money = file.getOrderMoney();
                      this.gridData.push(data);
                      this.moneys = this.moneys + file.getMoney();
                      this.orderMoney = this.orderMoney + file.getOrderMoney();
                      this.pages = this.pages + file.getPage();
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                      this.elUploadMdjy = "new-el-upload-mdjy";
                    }
                  })
                  .catch((error) => {
                    this.isShowupload = true;
                    clearInterval(time);
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      this.$router.push("/h5/login")
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                      this.elUploadMdjy = "new-el-upload-mdjy";
                    }
                  });
            };
          }).catch(err => {
        this.isShowupload = true;
        clearInterval(time);
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.$router.push("/h5/login")
        } else {
          this.$message.error("文件上传遇到了问题，请稍后再试！");
        }
      })
    },
    submitImgUploadFiles(event) {
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        if (!res.getIsoverstepcount()) {
          this.$message.error(res.getMessage());
          this.isImgUploadDisabled = true;
          this.elUploadMdjy = "new-el-upload-mdjy-none";
          return
        }
        this.isShowupload = false;
        this.isImgUploadDisabled = false;
        this.elUploadMdjy = "new-el-upload-mdjy";
        if (res.getCount() >= 10) {
          this.count = 10
          this.limitCount = res.getLimitcount();
        } else {
          this.count = res.getCount();
          this.limitCount = res.getLimitcount();
        }
        this.elUploadMdjy = "new-el-upload-mdjy-display";
        //上传进度
        let unm = 0;
        event.onProgress({percent: unm});
        let time = setInterval(function () {
          let Range = 5 - 1;
          let Rand = Math.random();
          unm = 1 + Math.round(Rand * Range) + unm;
          if (unm > 99) {
            unm = 99;
          }
          event.onProgress({percent: unm});
        }, 100);
        if (this.uploadform.from === "原文语言") {
          this.uploadform.from = "auto";
        }
        if (this.uploadform.to === "目标语言") {
          this.uploadform.to = "zh";
        }
        const files = this.$refs.fileUploadImg.$data.uploadFiles;
        const file = files[this.uploadCount];
        this.uploadCount = ++this.uploadCount;
        let request = uploadRequest;
        let reader = new FileReader();
        reader.readAsArrayBuffer(file.raw, "utf-8");
        const thatEvent = event;
        reader.onloadend = () => {
          request.setFile(new Uint8Array(reader.result));
          request.setName(file.name);
          request.setSize(file.size);
          request.setFrom(this.uploadform.from);
          request.setTo(this.uploadform.to);
          translateServiceClient
              .uploadImg(request, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
              .then((res) => {
                clearInterval(time);
                if (res.getStatus()) {
                  thatEvent.onProgress({percent: 100})
                  const file = res.getUploadfile();
                  const data = {};
                  data.id = file.getId();
                  data.title = file.getTitle();
                  data.page = file.getPage();
                  data.money = file.getOrderMoney();
                  this.gridData.push(data);
                  this.moneys = this.moneys + file.getMoney();
                  this.orderMoney = this.orderMoney + file.getOrderMoney();
                  this.pages = this.pages + file.getPage();
                  return;
                }
                this.$refs.fileUploadImg.clearFiles();
                this.uploadCount = --this.uploadCount;
                files.splice(this.uploadCount, 1);
                this.$refs.fileUploadImg.$data.uploadFiles = files;
                this.$message({
                  center: true,
                  type: 'error',
                  showClose: true,
                  duration: 6000,
                  message: res.getMessage()
                });
                if (files.length === 0) {
                  this.isImgUploadDisabled = false;
                  this.elUploadMdjy = "new-el-upload-mdjy";
                }
              })
              .catch((error) => {
                this.isShowupload = true;
                clearInterval(time);
                if (error && error.code === 5) {
                  localStorage.removeItem("token");
                  localStorage.removeItem("auth-context");
                  this.$router.push("/h5/login")
                  return;
                }
                this.$refs.fileUploadImg.clearFiles();
                this.uploadCount = --this.uploadCount;
                files.splice(this.uploadCount, 1);
                this.$refs.fileUploadImg.$data.uploadFiles = files;
                this.$message.error("上传文件失败");
                if (files.length === 0) {
                  this.isImgUploadDisabled = false;
                  this.elUploadMdjy = "new-el-upload-mdjy";
                }
              });
        };
      }).catch(err => {
        this.isShowupload = true;
        clearInterval(time);
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.$router.push("/h5/login")
        } else {
          this.$message.error("文件上传遇到了问题，请稍后再试！");
        }
      })
    },
    onExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10个文件！");
        this.isUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error("当前账户仅支持24小时内上传" + this.limitCount + "篇文献")
        this.isUploadDisabled = true;
        this.elUploadMdjy = "new-el-upload-mdjy-none";
        return;
      }
      this.$message({
        center: true,
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" + this.limitCount + "篇文献，您还剩余&nbsp;<span style='font-size:20px;'>" + this.count + "</span>&nbsp;篇</span>"
      });
      this.elUploadMdjy = "new-el-upload-mdjy";
      this.isUploadDisabled = false;
    },
    onImgExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10张图片！");
        this.isImgUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error("当前账户仅支持24小时内上传" + this.limitCount + "张图片")
        this.isImgUploadDisabled = true;
        this.elUploadMdjy = "new-el-upload-mdjy-none";
        return;
      }
      this.$message({
        center: true,
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" + this.limitCount + "张图片，您还剩余&nbsp;<span style='font-size:20px;'>" + this.count + "</span>&nbsp;张</span>"
      });
      this.elUploadMdjy = "new-el-upload-mdjy";
      this.isImgUploadDisabled = false;
    },
    beforeImgUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const extension =
          testmsg === "jpg" ||
          testmsg === "jpeg" ||
          testmsg === "png" ||
          testmsg === "tif";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "图片类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的图片内容为空！");
        return false;
      }
      const islimit = file.size < 4194304 / 2;
      if (!islimit) {
        this.$message.error("图片上传大小不能超过2M！");
      }
      return extension && islimit;
    },
    beforeUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const extension =
          testmsg === "xls" ||
          testmsg === "xlsx" ||
          testmsg === "pdf" ||
          testmsg === "ppt" ||
          testmsg === "pptx" ||
          testmsg === "doc" ||
          testmsg === "docx" ||
          testmsg === "txt";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 20971520;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      let isSuccess = extension && islimit
      if (isSuccess) {
        this.elUploadMdjy = "new-el-upload-mdjy-none";
      }
      return isSuccess;
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .payClass1 {
  .el-dialog {
    min-width: 800px;
  }

  .el-dialog__footer {
    padding: 10px 30px 20px !important;
    line-height: 41px;
  }

  .el-dialog__body {
    padding: 30px 30px !important;
  }

  .el-dialog__header {
    padding: 20px 30px 10px !important;
    line-height: 50px;
  }

}

/deep/ .dialog-title {
  text-align: left;
  width: 100%;
  margin-bottom: 30px;

  .el-form--inline .el-form-item, .el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: baseline;
    margin: 0;
    padding: 0;
  }
}

.new-el-upload-mdjy-none {
  background-color: #f5f5f5;
  border: 1px dashed #cccccc;
  width: 350px;
  height: 224px;
  display: inline-block;
  text-align: center;
  padding-top: 20px;
}

.triangle {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 590px;
  height: 45px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  text-align: center;
  position: relative;
  border: 0px solid #999999;
}

.triangle:before {
  position: absolute;
  content: "";
  top: -10px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 12px solid #99999991;
}

/* 白色覆盖*/
.triangle:after {
  position: absolute;
  content: "";
  /*减少两像素*/
  top: -8px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ffffff;
}

.is-active {
  border-bottom: 4px solid #063F95;
}

/deep/ .new-el-upload-mdjy-display {
  .el-upload {
    display: none;
  }
}

.trans-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;
  border-bottom: 1px solid #DDDDDD;

  .trans-header {
    width: 100%;
    height: 80px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    justify-content: center;

    .trans-header-select {
      width: 765px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      div {
        margin: 0 34px;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
        height: 74px;
      }
    }

  }

  .trans-main-content {
    width: 768px;
    height: 993px;
    background: #FFFFFF;

    .trans-main-content-ok {
      height: 689px;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;

      .trans-main-content-ok-font {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 1px;

        div:nth-child(1) {
          margin-right: 14px;
        }
      }

      .trans-main-content-ok-button{
        width: 261px;
        height: 60px;
        background: #063F95;
        border-radius: 35px 0px 35px 0px;
        margin-top: 48px;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #F5F5F5;
        line-height: 52px;
        text-align: center;
      }
    }

    .trans-main-content-select {
      width: 100%;
      margin-top: 51px;
      margin-bottom: 113px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        margin: 0 90px;
      }

      /deep/ .el-select {
        .el-input {
          width: 200px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;

          input {
            border: 0;
            padding: 0;
            text-align: center;
          }

          .el-input__suffix {
            display: none;
          }
        }
      }
    }

    /deep/ .demo-form-inline {
      .el-upload-dragger {
        height: 320px;
        width: 541px;
        border: 2px dashed #d9d9d9;

        .new-el-upload-mdjy {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          line-height: 30px;
          cursor: pointer;

          .content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .el-upload-titjy {
              font-family: "Microsoft YaHei";
              font-weight: 400;
              font-size: 24px;
              color: #333333;
              margin-bottom: 20px;
            }

            .scbncg {
              font-family: "Microsoft YaHei";
              font-weight: 400;
            }

            .uptitle {
              margin-top: 40px;
              font-family: "Source Han Sans CN";
              font-weight: 400;
              font-size: 24px;
              display: flex;
              width: 261px;
              height: 60px;
              align-items: center;
              justify-content: center;
              background: #063F95;
              border-radius: 26px 0px 26px 0px;
              color: #F5F5F5;
            }
          }
        }
      }

      .el-upload-list {
        margin-bottom: 30px !important;
        margin-right: -55px;
        margin-top: -60px;

        .el-upload-list__item .el-progress {
          position: absolute;
          top: 38px;
          width: 623px;
        }

        .el-progress__text {
          font-size: 24px !important;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }

        .el-upload-list__item .el-progress__text {
          position: absolute;
          right: 0;
          top: -26px;
        }

        .el-upload-list__item {
          text-align: left;
          transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 1.8;
          margin-top: 53px;
          position: relative;
          box-sizing: border-box;
          border-radius: 4px;
          width: 623px;

          .el-upload-list__item-name {
            color: #999999 !important;
            width: 560px;
          }

          .el-icon-document {
            position: absolute;
            margin-left: -69px;
            margin-top: -2.5px;
            font-size: 45px;
            color: #bebebe;
          }

          .el-progress-bar__outer {
            height: 17px !important;
          }

          .el-progress-bar__inner {
            background-color: #4dbe92 !important;
          }

          .el-icon-upload-success {
            display: none;
            color: #67c23a;
            position: absolute;
            margin-left: 19px;
            margin-top: 7.5px;
            font-size: 26px;
          }
        }
      }
    }

    /deep/ .new-el-upload-manjy {
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .el-divider.el-divider--horizontal {
        width: 470px;
        margin: 0;

        .el-divider__text.is-center {
          font-size: 24px;
          font-family: "Microsoft YaHei";
          color: #999999;
        }
      }

    }

    .list {
      margin-top: 70px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 80%;

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #999999;

        span {
          margin-top: 10px;
        }
      }
    }

    .text-input {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      /deep/ .originaltext {
        width: 300px;

        /deep/ .el-input__count {
          color: #909399;
          position: absolute;
          font-size: 24px;
          bottom: 5px;
          right: 10px;
        }

        .el-textarea__inner {
          border: 0;
        }
      }
    }
  }

  .trans-main-content-text {
    width: 704px;
    height: 480px;
    background: #FFFFFF;
    box-shadow: 0px 5px 5px 0px rgba(3, 27, 63, 0.1);

    .trans-main-content-select {
      width: 100%;
      margin-top: 51px;
      margin-bottom: 50px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        margin: 0 90px;
      }

      /deep/ .el-select {
        .el-input {
          width: 200px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;

          input {
            border: 0;
            padding: 0;
            text-align: center;
          }

          .el-input__suffix {
            display: none;
          }
        }
      }
    }

    /deep/ .demo-form-inline {
      .el-upload-dragger {
        height: 320px;
        width: 541px;
        border: 2px dashed #d9d9d9;

        .new-el-upload-mdjy {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          line-height: 30px;
          cursor: pointer;

          .content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .el-upload-titjy {
              font-family: "Microsoft YaHei";
              font-weight: 400;
              font-size: 24px;
              color: #333333;
              margin-bottom: 20px;
            }

            .scbncg {
              font-family: "Microsoft YaHei";
              font-weight: 400;
            }

            .uptitle {
              margin-top: 40px;
              font-family: "Source Han Sans CN";
              font-weight: 400;
              font-size: 24px;
              display: flex;
              width: 261px;
              height: 60px;
              align-items: center;
              justify-content: center;
              background: #063F95;
              border-radius: 26px 0px 26px 0px;
              color: #F5F5F5;
            }
          }
        }
      }

      .el-upload-list {
        margin-bottom: 30px !important;
        margin-right: -55px;
        margin-top: -60px;

        .el-upload-list__item .el-progress {
          position: absolute;
          top: 38px;
          width: 623px;
        }

        .el-progress__text {
          font-size: 24px !important;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }

        .el-upload-list__item .el-progress__text {
          position: absolute;
          right: 0;
          top: -26px;
        }

        .el-upload-list__item {
          text-align: left;
          transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 1.8;
          margin-top: 53px;
          position: relative;
          box-sizing: border-box;
          border-radius: 4px;
          width: 623px;

          .el-upload-list__item-name {
            color: #999999 !important;
            width: 560px;
          }

          .el-icon-document {
            position: absolute;
            margin-left: -69px;
            margin-top: -2.5px;
            font-size: 45px;
            color: #bebebe;
          }

          .el-progress-bar__outer {
            height: 17px !important;
          }

          .el-progress-bar__inner {
            background-color: #4dbe92 !important;
          }

          .el-icon-upload-success {
            display: none;
            color: #67c23a;
            position: absolute;
            margin-left: 19px;
            margin-top: 7.5px;
            font-size: 26px;
          }
        }
      }
    }

    /deep/ .new-el-upload-manjy {
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .el-divider.el-divider--horizontal {
        width: 470px;
        margin: 0;

        .el-divider__text.is-center {
          font-size: 24px;
          font-family: "Microsoft YaHei";
          color: #999999;
        }
      }

    }

    .list {
      margin-top: 70px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 80%;

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #999999;

        span {
          margin-top: 10px;
        }
      }
    }

    .text-input {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      /deep/ .originaltext {
        width: 345px;

        .el-input__count {
          color: #909399;
          position: absolute;
          font-size: 24px;
          bottom: 5px;
          right: 10px;
        }

        .el-textarea__inner {
          border: 0;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
        }
      }
    }
  }

  .trans-main-content-text-tip {
    margin-bottom: 474px;
    margin-top: 20px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    width: 704px;
    margin-left: 50px;
  }
}

.custom-select-class {

  .el-select-dropdown__list {
    .el-select-group__wrap {
      .el-select-group__title {
        font-size: 24px;
      }
    }
  }


  .el-select-group .el-select-dropdown__item {
    font-size: 24px;
  }

  .el-select-dropdown__item.selected {
    color: #063F95;
    font-weight: 700;
  }


}
</style>
